import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties/StringProperty';

export const PlatePairSchema = new GenericModelSchema('platePair', {
  category: ModelCategory.ComponentDesignData,
  pluralName: 'Plates',

  properties: {
    name: StringProperty,
  },
});
